import { render, staticRenderFns } from "./substituteHoliday.vue?vue&type=template&id=23f8162a&"
import script from "./substituteHoliday.vue?vue&type=script&lang=js&"
export * from "./substituteHoliday.vue?vue&type=script&lang=js&"
import style0 from "./substituteHoliday.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports